import { Resource } from './resource';

export class JobCategory extends Resource {
    name: string;
    value : string;
    label :string;
  }